// removed by extract-text-webpack-plugin
module.exports = {"injuryStatus":"InjuryStatus__injuryStatus--3MIGA","injuryStatusIcon":"InjuryStatus__injuryStatusIcon--hv5Av","printableInjuryStatus":"InjuryStatus__printableInjuryStatus--r7kP2","printableInjuryStatusIcon":"InjuryStatus__printableInjuryStatusIcon--37A6r"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/TableControls/InjuryStatus/InjuryStatus.css
// module id = ohkB
// module chunks = 47